<template>
	<div id="onboardingOptions" class="container-fluid mt-2">
		<Breadcrumb :back="'/kpi'" />
		<div class="row my-5">
			<div class="col-md-12">
				<iframe
					src="https://calendar.google.com/calendar/embed?src=c_84aa35cd9384e49e7353dbb7222da3dbafdccfffcca9ad84dfbe98ec8d7bee24%40group.calendar.google.com&ctz=Europe%2FBelgrade"
					style="border: 0"
					width="100%"
					height="700"
					frameborder="0"
					scrolling="no"
				></iframe>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import restApi from '../../api/index'
import Breadcrumb from '../../components/onboarding/breadcrumb/Breadcrumb.vue'

export default {
	name: 'KpiDevelopment',
	data() {
		return {
			loading: false,
		}
	},
	components: { Breadcrumb },
	computed: {
		...mapState(['authUser']),
		...mapGetters(['isAuth']),
	},
	mounted() {},
	created() {},
	methods: {
		// Programming
		getOnboartingTypes() {
			restApi
				.get('/onboarding-type')
				.then(({ data }) => {
					this.onboardingTypes = data
				})
				.catch(error => {
					console.log(error)
				})
		},
	},
	watch: {},
}
</script>
